import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

/**
 * Fetches stored site-verification tokens for Google/Bing/Yandex from the
 * backend (`/api/seo/verification/{engine}`) and injects them as meta tags
 * into the document head.
 *
 * Place once near the top of the App tree. The prerender script picks these
 * up in the crawled snapshot.
 */
export default function SeoVerificationTags() {
  const [tags, setTags] = useState({ google: null, bing: null, yandex: null });

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const engines = ['google', 'bing', 'yandex'];
    Promise.all(
      engines.map((engine) =>
        axios
          .get(`${API}/api/seo/verification/${engine}`)
          .then((res) => [engine, res.data?.content])
          .catch(() => [engine, null])
      )
    ).then((results) => {
      const obj = {};
      results.forEach(([engine, content]) => {
        obj[engine] = content;
      });
      setTags(obj);
    });
  }, []);

  return (
    <Helmet>
      {tags.google && (
        <meta
          name="google-site-verification"
          content={tags.google.replace(/^google-site-verification=/, '').trim()}
        />
      )}
      {tags.bing && <meta name="msvalidate.01" content={tags.bing.trim()} />}
      {tags.yandex && <meta name="yandex-verification" content={tags.yandex.trim()} />}
    </Helmet>
  );
}
